var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { createCssVarDefinitions, createCssVars } from '@creditornot/cb-utils';
import colors from '../colors';
import { cssVarsThemed } from '../cssUtils';
var cssVars = createCssVars(['size']);
var sizeConfig = {
    tiny: 14,
    small: 18,
    medium: 24,
    large: 44,
    extraLarge: 64,
    huge: 96,
};
var colorConfig = {
    blue: {
        light: colors.wolt100,
        dark: colors.wolt100,
    },
    lightGrey: {
        light: colors.pepper40,
        dark: colors.salt48,
    },
    grey: {
        light: colors.pepper64,
        dark: colors.salt72,
    },
    white: {
        light: colors.salt100,
        dark: colors.space100,
    },
    red: {
        light: colors.strawberry100,
        dark: colors.strawberry100,
    },
};
var SpinnerIcon = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 50 50" }, props),
    React.createElement("circle", { className: "bgPath", cx: "25", cy: "25", fill: "none", r: "20", strokeWidth: "5" }),
    React.createElement("circle", { className: "mainPath", cx: "25", cy: "25", fill: "none", r: "20", strokeWidth: "5" }))); };
var keyframesRotate = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var keyframesDash = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n 0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n"], ["\n 0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n"])));
var colorCssVars = createCssVars(['strokeColor']);
var StyledSpinner = styled(SpinnerIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  width: ", ";\n  height: ", ";\n  display: inline-block;\n\n  animation: ", " ", "ms infinite linear;\n\n  .bgPath {\n    stroke: ", ";\n    stroke-opacity: 0.2;\n  }\n\n  .mainPath {\n    stroke: ", ";\n    stroke-linecap: round;\n    animation: ", " 1.5s ease-in-out infinite;\n  }\n"], ["\n  ", "\n\n  ", "\n\n  width: ", ";\n  height: ", ";\n  display: inline-block;\n\n  animation: ", " ", "ms infinite linear;\n\n  .bgPath {\n    stroke: ", ";\n    stroke-opacity: 0.2;\n  }\n\n  .mainPath {\n    stroke: ", ";\n    stroke-linecap: round;\n    animation: ", " 1.5s ease-in-out infinite;\n  }\n"])), function (_a) {
    var $cssVarOverrides = _a.$cssVarOverrides, $size = _a.$size;
    return createCssVarDefinitions(__assign({ size: "".concat(sizeConfig[$size], "px") }, $cssVarOverrides));
}, function (_a) {
    var $color = _a.$color;
    return cssVarsThemed({
        strokeColor: colorConfig[$color],
    });
}, cssVars.size, cssVars.size, keyframesRotate, function (_a) {
    var $animationSpeed = _a.$animationSpeed;
    return $animationSpeed;
}, colorCssVars.strokeColor, colorCssVars.strokeColor, keyframesDash);
/**
 * @deprecated use `Spinner` from `@creditornot/cb-progress` instead.
 */
var Spinner = function (_a) {
    var _b = _a.animationSpeed, animationSpeed = _b === void 0 ? 1500 : _b, _c = _a.color, color = _c === void 0 ? 'blue' : _c, cssVarOverrides = _a.cssVarOverrides, size = _a.size, rest = __rest(_a, ["animationSpeed", "color", "cssVarOverrides", "size"]);
    return (React.createElement(StyledSpinner, __assign({ "$animationSpeed": animationSpeed, "$color": color, "$cssVarOverrides": cssVarOverrides, "$size": size }, rest)));
};
export default Spinner;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Spinner.js.map